

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const expensesAtomData = atom({key:'expensesAtom_Data', default:{vendor_info:[],tax_info:[],

    paid_account:[], expense_status:[], expense_info:[], expense_account:[]}});

const expensesEditAtom = atom({key:'expensesAtom_edit', default:{}});







export  const SetExpenseEdit = () => useSetRecoilState(expensesEditAtom);
export  const GetExpenseEdit = () => useRecoilValue(expensesEditAtom);


export  const SetExpenseListData = () => useSetRecoilState(expensesAtomData);
export  const GetExpenseListData = () => useRecoilValue(expensesAtomData);




